import { ApartmentOutlined, LocationCity } from "@mui/icons-material";
import {
  Badge,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import EmptyResult from "components/Shared/Lottie/EmptyResult";
import React from "react";
import { Link } from "react-router-dom";

const BranchAssignmentRegionTab = ({ regionDetail }) => {
  const regions =
    regionDetail && Array.isArray(regionDetail) ? regionDetail : [];

  return (
    <Grid item xs={12}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={3}
      >
        <Box display="inline-flex" alignItems="center" gap={1.5}>
          <Badge badgeContent={regions.length} color="primary">
            <LocationCity style={{ color: "gray" }} />
          </Badge>

          <Typography style={{ fontWeight: 500 }}>Regions</Typography>
        </Box>
      </Box>

      <Divider />
      <Box p={2}>
        {regions.length > 0 ? (
          <RegionCard regions={regions} />
        ) : (
          <EmptyResult height={150} />
        )}
      </Box>
    </Grid>
  );
};

export default BranchAssignmentRegionTab;

const RegionCard = ({ regions = [] }) => {
  const validRegions = regions.filter((region) => region?.id && region?.label);

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {validRegions?.length > 0 ? (
        validRegions.map((region) => (
          <div key={region?.id} className="group">
            <Link to={`/app/crm/region/${region?.id}/detail`}>
              <Card
                className="h-full transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl"
                sx={{
                  borderRadius: 2,
                  "&:hover": {
                    boxShadow:
                      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  },
                }}
              >
                <CardContent sx={{ padding: 2 }}>
                  <div className="flex items-center gap-3">
                    <div className="rounded-full bg-blue-100 p-2 transition-colors group-hover:bg-blue-200">
                      <ApartmentOutlined
                        sx={{
                          fontSize: 20,
                          color: "primary.main",
                        }}
                      />
                    </div>
                    <Typography
                      variant="body2"
                      className="line-clamp-2 font-medium"
                    >
                      {region.label}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            </Link>
          </div>
        ))
      ) : (
        <EmptyResult height={150} />
      )}
    </div>
  );
};
